<app-data-table mainTitle="Enquadramentos"
                singleTitle="Enquadramento"
                routerPath="/siscoserv/enquadramento"
                entityPath="/tbcodenquadra"
                [entity]="tbCodEnquadra"
                [columns]="this['columns']"
                [controls]="this['controls']">
</app-data-table>
